module.exports = "https://web-assets-production.autolist.com/_next/static/images/raleigh-nc-e397a54e6ba6c053f7985b679e467e19.jpg";